import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RecusaCancelarOperacaoComponent } from './recusa-cancelar-operacao.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
  ],
  exports: [
    RecusaCancelarOperacaoComponent
  ],
  declarations: [RecusaCancelarOperacaoComponent]
})
export class RecusaCancelarOperacaoComponentModule {
}
